/* eslint-disable */
import {getDriverGPSServerInstance} from "@/data-services/driver-gps-service";

export function avatarBackground(nickname) {
  let sum = 0
  nickname = nickname || '';
  for(let i = 0; i<nickname.length; i++) {
    sum += nickname.charCodeAt(i)
  }
  const backgroundColors = ["#9395e9", "#5fb0ff", "#f79994", "#70daa0", "#c770da"];
  return backgroundColors[sum % backgroundColors.length]
}

export function avatarText(nickname) {
  if (nickname) {
    return nickname
      .split(" ")
      .map(i => i[0])
      .slice(0, 2)
      .join("").toUpperCase();
  } else {
    return "";
  }
}
